import { connect } from 'react-redux'
import DecryptPasswordForm from '../components/DecryptPasswordForm'
import { unlockPrivateKey } from '../services/crypto/actions'

const mapStateToProps = ({
  crypto: { wrongPassword, unlockPending, keyPasswordAttempt }
}) => ({
  wrongPassword,
  unlockPending,
  keyPassword: keyPasswordAttempt
})

const mapDispatchToProps = { unlockPrivateKey }

export default connect(mapStateToProps, mapDispatchToProps)(DecryptPasswordForm)



// WEBPACK FOOTER //
// ./src/containers/DecryptPasswordForm.js